import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5e2487a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mock-page"
};
const _hoisted_2 = {
  class: "mock-card"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mock-icon"
}, "💰", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mock-title"
}, "模拟支付页", -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mock-tip"
}, "（仅本地联调用，真实上线前可删除）", -1));
const _hoisted_6 = {
  key: 0,
  class: "mock-info"
};
const _hoisted_7 = {
  key: 1,
  class: "mock-info"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "订单加载中...", -1));
const _hoisted_9 = [_hoisted_8];
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { showNotify } from '@nutui/nutui';
import service from '@/utils/request';
export default {
  __name: 'PayMockView',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const order = ref(null);
    const loading = ref(false);
    const loadOrder = () => {
      const outTradeNo = route.query.outTradeNo;
      if (!outTradeNo) return;
      service.get('/pay/query', {
        params: {
          outTradeNo
        }
      }).then(res => {
        if (res.code == 200) order.value = res.data;
      });
    };
    const mockPay = async () => {
      const outTradeNo = route.query.outTradeNo;
      if (!outTradeNo) {
        showNotify.warn('订单号缺失');
        return;
      }
      loading.value = true;
      try {
        const res = await service.post('/pay/mockNotify', null, {
          params: {
            outTradeNo
          }
        });
        if (res === 'success') {
          showNotify.success('模拟支付成功');
          router.replace({
            path: '/recharge',
            query: {
              outTradeNo
            }
          });
        } else {
          showNotify.warn('模拟支付失败');
          loading.value = false;
        }
      } catch (e) {
        loading.value = false;
      }
    };
    onMounted(loadOrder);
    return (_ctx, _cache) => {
      const _component_nut_button = _resolveComponent("nut-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _hoisted_5, order.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("p", null, "订单号：" + _toDisplayString(order.value.outTradeNo), 1), _createElementVNode("p", null, "充值金额：" + _toDisplayString(order.value.beans) + " 鲸豆", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)), _createVNode(_component_nut_button, {
        type: "primary",
        block: "true",
        loading: loading.value,
        onClick: mockPay
      }, {
        default: _withCtx(() => [_createTextVNode("模拟支付成功")]),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
};